import { ChevronDownIcon, ChevronUpIcon } from '@heroicons/react/24/outline';
import { Button, Dropdown, DropdownItem, DropdownMenu, DropdownTrigger } from '@nextui-org/react';
import React, { useEffect, useState } from 'react';

import { TypographyUI } from '@portal/components/common/Typography.ui';

type SelectPageSizeProps = {
  totalData: number;
  selectedPageSize: number;
  onSelectedPageSizeChange: (_: number) => void;
};

export const SelectPageSize = (props: SelectPageSizeProps) => {
  const [isDown, setIsDown] = useState(false);
  const [selectedPageSizeKeys, setSelectedPageSizeKeys] = React.useState(new Set([props.selectedPageSize.toString()]));
  const pageSize = parseInt(Array.from(selectedPageSizeKeys)[0]);

  useEffect(() => {
    setSelectedPageSizeKeys(new Set([props.selectedPageSize.toString()]));
  }, [props.selectedPageSize]);

  useEffect(() => {
    props.onSelectedPageSizeChange(pageSize);
  }, [pageSize]);

  return (
    <div className='flex items-center'>
      <TypographyUI className='text-tl '>Rows per page: </TypographyUI>
      <Dropdown onClose={() => setIsDown(false)}>
        <DropdownTrigger>
          <Button
            variant='light'
            className='flex items-center capitalize min-w-unit-14'
            onPress={() => setIsDown(!(isDown || false))}
          >
            {pageSize == props.totalData ? 'All' : pageSize}
            {!isDown ? (
              <ChevronDownIcon strokeWidth={2} className='h-4 w-4' />
            ) : (
              <ChevronUpIcon strokeWidth={2} className='h-4 w-4' />
            )}
          </Button>
        </DropdownTrigger>
        <DropdownMenu
          variant='flat'
          disallowEmptySelection
          selectionMode='single'
          onSelectionChange={s => setSelectedPageSizeKeys(s as Set<string>)}
        >
          <DropdownItem key={10}>10</DropdownItem>
          <DropdownItem key={25}>25</DropdownItem>
          <DropdownItem key={50}>50</DropdownItem>
          <DropdownItem key={100}>100</DropdownItem>
          <DropdownItem key={props.totalData}>All</DropdownItem>
        </DropdownMenu>
      </Dropdown>
    </div>
  );
};
